import { render, staticRenderFns } from "./VgtTableHeader.vue?vue&type=template&id=d90ddb36&"
import script from "./VgtTableHeader.vue?vue&type=script&lang=js&"
export * from "./VgtTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sergey/projects/www/alfa-b2b/htdocs/local/templates/b2bportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d90ddb36', component.options)
    } else {
      api.reload('d90ddb36', component.options)
    }
    module.hot.accept("./VgtTableHeader.vue?vue&type=template&id=d90ddb36&", function () {
      api.rerender('d90ddb36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/vgt/VgtTableHeader.vue"
export default component.exports